import React from "react";
import "./forWhom.scss";

//imagens:
import ImgForBusinessman from "../../../../assets/homeImgs/imgForBusinessman.svg";
import ImgForBusinessArchitects from "../../../../assets/homeImgs/imgForBusinessArchitects.svg";
import ImgForConsultants from "../../../../assets/homeImgs/imgForConsultants.svg";
import { useTranslation } from "react-i18next";



const ForWhomCard = ({img, imgAlt, titleWhom, textWhom }) => (
  <div data-aos="flip-left" data-aos-easing="ease-out-cubic" data-aos-duration="2000" className="div-for">
    <div className="img-for">
      <img src={img} alt={imgAlt} />
    </div>
    <div className="text-for">
      <h1>{titleWhom}</h1>
      <p>{textWhom}</p>
      {/* <button className="btn-for-whom">SAIBA MAIS!</button> */}
    </div>
  </div>
)


const ForWhom = () => {
  const {t} = useTranslation()

  return (
    <div className="container-for-whom">
      <ForWhomCard img={ImgForBusinessman} imgAlt="Empresário" titleWhom={t("home.for_whom.business_man.title")} textWhom={t("home.for_whom.business_man.section_text")} />
      <ForWhomCard img={ImgForBusinessArchitects} imgAlt="Arquitetos de Negócio" titleWhom={t("home.for_whom.business_architects.title")} textWhom={t("home.for_whom.business_architects.section_text")} />
      <ForWhomCard img={ImgForConsultants} imgAlt="Consultores" titleWhom={t("home.for_whom.consultants.title")} textWhom={t("home.for_whom.consultants.section_text")} />
    </div>
  );
};
export default ForWhom;
